/* Override Main Colors */

// Primary Colors (light black)
export const primary = '#1b1b1b';
export const primary50 = 'rgba(27,27,27, 0.5)';

// Secondary Colors (yellow)
export const secondary = '#ffcc1b';
export const secondary50 = 'rgba(255, 204, 27, 0.5)';

// Error Color
export const error = 'red';

// Light Grey
export const grey = 'rgba(27, 27, 27, 0.3)';
export const grey30 = 'rgba(21,21,21, 0.3)';
export const grey50 = 'rgba(21,21,21, 0.5)';


// WEBPACK FOOTER //
// ./src/utils/Color.js